export default {
  recruitingBanner: { priority: 0 },
  warBanner: { priority: 1 },
};
